const instoreMainWrap = () => import("@/views/main_wrap.vue");

const createInstoreViewRoute = ({ path, name, component, aliases = [] }) => ({
    path,
    name,
    alias: aliases,
    component: instoreMainWrap,
    children: [
        {
            path: "",
            component
        }
    ]
});

export const instoreRoutes = [
    createInstoreViewRoute({
        path: "/instore/partnership",
        name: "Gsrse01",
        aliases: [
            "/gsrse01",
            "/gsrse02",
            "/gsrse03",
            "/instore/gsrse01",
            "/instore/gsrse02",
            "/instore/gsrse03"
        ],
        component: () => import("@/views/instore/01/gsrse01.vue")
    })
];
